import { clerkMiddleware } from '@clerk/tanstack-react-start/server';
import { createStart } from '@tanstack/react-start';

export const startInstance = createStart(() => {
  // SPA prerender runs a short-lived Node server; Clerk needs CLERK_SECRET_KEY.
  // Skip middleware when unset so local/tooling builds still work.
  const hasSecret = Boolean(process.env.CLERK_SECRET_KEY);
  return {
    requestMiddleware: hasSecret ? [clerkMiddleware()] : [],
  };
});
